import {
  EcommerceAPIApi as EcommerceApi,
  type EcommerceSessionTimeoutResponse,
} from '@parkingbase/ecommerce-api-dev';

import { BaseApiService } from './baseApi.service';

/**
 * The company's automatic sign-out policy for e-commerce customers (PB-5476).
 *
 * Every field on `EcommerceSessionTimeoutResponse` is optional on purpose: a frontend deployed
 * ahead of the api sees `undefined`, and that must read as "never sign anyone out".
 */
export class SessionTimeoutService extends BaseApiService {
  protected sessionTimeoutApi: EcommerceApi;

  constructor() {
    super();
    this.sessionTimeoutApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  /**
   * Reads this domain's company policy; the api resolves the company from the request domain,
   * so this takes no company argument.
   *
   * ## Invariants:
   * - Rejections are NOT caught here. Why: the api answers 404 for a company that never saved
   *   login settings, which is the normal case rather than an incident, and the caller
   *   (`useSessionTimeoutConfig`) is the layer that degrades it to "disabled" and logs it. A
   *   catch here would leave the caller unable to tell a real policy from a swallowed failure.
   */
  async getSessionTimeoutConfig(): Promise<EcommerceSessionTimeoutResponse> {
    const response = await this.sessionTimeoutApi.getSessionTimeoutForEcommerce();
    return response.data;
  }
}
